import React, {useRef} from 'react';
import Herobanner from "../Componentes/Herobanner/Herobanner";
import ExclusiveListings from "../Componentes/ExclusiveListings/ExclusiveListings";
import Architecturalgallery from "../Componentes/Architecturalgallery/Architecturalgallery";
import Cinematictour from "../Componentes/Cinematictour/Cinematictour";
import Livingstandards from "../Componentes/Livingstandards/Livingstandards";
import Residentssay from "../Componentes/Residentssay/Residentssay";

const HomePage = () => {
	const listingRef = useRef (null);
	
	const scrollToListings = () => {
		listingRef.current?.scrollIntoView ({behavior: 'smooth'});
	};
	
	return (
		<>
			<Herobanner onViewClick={scrollToListings}/>
			<div ref={listingRef}>
				<ExclusiveListings/>
			</div>
			<Architecturalgallery/>
			<Cinematictour/>
			<Livingstandards/>
			<Residentssay/>
		</>
	);
};

export default HomePage;